import { removeFromStorage } from 'ha/utils/storage';
import { Thunk } from 'ha/myredux/types';
import {
  BILLING_INFO_STORAGE_KEY,
  SHOW_WE_WANT_TO_PAY_STORAGE_KEY,
} from 'ha/modules/WeWantToPay/constants';
import { AuthLogicActions } from './actions';

const fetchImpersonationInfo: () => Thunk =
  () =>
  (dispatch, _, { apiV2 }) =>
    apiV2
      .getUserInformation('me', {
        expand: 'impersonation',
      })
      .then(({ data: { impersonation } }) => {
        if (impersonation) {
          dispatch(AuthLogicActions.fulfillImpersonation(impersonation));

          removeFromStorage(BILLING_INFO_STORAGE_KEY);
          removeFromStorage(SHOW_WE_WANT_TO_PAY_STORAGE_KEY);
        }
      })
      .catch(() => {
        // do nothing
      });

export default fetchImpersonationInfo;
